import React from 'react';
import Link from 'next/link';
import { Category, Company } from '../../../models';
import CatalogueRowCarousel from './CatalogueRowCarousel';

interface CategoriesSectionRowProps {
  sections: { allies: Company[]; category: Category }[];
}

function CategoriesSectionRow({ sections }: CategoriesSectionRowProps) {
  return (
    <div className="w-full flex flex-col gap-5">
      <div className="flex flex-row gap-2 items-end">
        <p className="text-neutral-cold-800 text-lg lg:text-xl text-left font-semibold">
          {sections[0].category?.name}
        </p>
        <Link href={`/category/${sections[0].category?._id}`}>
          <p className="text-color-primary-text-300 hover:text-color-primary-text-100">
            Explorar todos
          </p>
        </Link>
      </div>
      <div className="mx-10">
        {sections?.map((sectionContent) => (
          <CatalogueRowCarousel
            key={sectionContent.category._id}
            sections={[
              {
                allies: sectionContent.allies,
                categoryId: sectionContent.category._id,
              },
            ]}
          />
        ))}
      </div>
    </div>
  );
}

export default CategoriesSectionRow;
